import {
  type TableColumn,
  createDateTimeColumn,
  createEnumColumn,
  createTextColumn,
} from '@ipfabric/utils';
import { Table } from 'components/Table/components/Table';
import { useFrontendLocalTable } from 'components/Table/model/useFrontendLocalTable';
import { useLocale } from 'containers/App/LocaleContext';
import type { TaskErrorReason } from 'pages/SnapshotManagement/Tasks/TaskErrorReason';
import { useMemo } from 'react';
import type { FC } from 'react';
import { exceptionsTypesByKey } from 'translations/exceptions';

type Props = {
  errorReasons: TaskErrorReason[];
};

export const ErrorReasonsDetail: FC<Props> = (props) => {
  const errorDetailMsg = useLocale().snapshotManagementTasks.errorDetail;
  const columns: TableColumn<any>[] = useMemo(
    () => [
      createDateTimeColumn({
        key: 'ts',
        title: errorDetailMsg.columns.ts,
        format: 'dateTimeFormat',
      }),
      createEnumColumn({
        key: 'errType',
        options: exceptionsTypesByKey,
        title: errorDetailMsg.columns.errType,
      }),
      createTextColumn({
        key: 'msg',
        title: errorDetailMsg.columns.msg,
      }),
      createTextColumn({
        key: 'source',
        title: errorDetailMsg.columns.source,
      }),
    ],
    [errorDetailMsg],
  );

  const frontendSimpleFilter = useFrontendLocalTable({
    columns,
    data: props.errorReasons,
  });

  return (
    <Table
      id='snapshotManagementTaskErrorReasonsDetail'
      title={errorDetailMsg.title}
      borderless
      className='flex-1'
      columns={columns}
      {...frontendSimpleFilter}
    />
  );
};
